import { Component, OnInit } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { RestService } from 'src/app/services/rest/rest.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { Tarifa } from 'src/app/interfaces/tarifa';
import { ProductById } from 'src/app/data/products';

@Component({
  selector: 'app-tarifas',
  templateUrl: './tarifas.page.html',
  styleUrls: ['./tarifas.page.scss'],
})
export class TarifasPage implements OnInit {
  selectedTab = '5eb9c9e3d0ca13a4332680dc';
  selectedView = 'main';
  editFields = false;
  editedId: string;

  columns = [
    {
      field: 'name',
      name: 'tarifa',
      width: 40
    },
    {
      field: 'price',
      name: 'precio',
      width: 40
    },
    {
      field: 'iva',
      name: 'IVA %',
      width: 40
    },
    {
      field: 'action',
      name: 'acciones rápidas',
      width: 20,
      actions: [
        {
          type: 'delete'
        },
        {
          type: 'edit'
        }
      ]
    }
  ];


  // linesCubito = [];
  // linesPilee = [];
  // linesEscama = [];
  // linesTriturado = [];
  // linesCuadrado = [];
  lines5eb9c9e3d0ca13a4332680dc = []; // CUBITO VOGT
  lines5eb9c9e3d0ca13a4332680db = []; // CUBITO SCOTSMAN
  lines5eb9c9e3d0ca13a4332680d9 = []; // HIELO PILEE
  lines5eb9c9e3d0ca13a4332680da = []; // ESCAMA RED
  lines5ef5e43bdd4795f0c32a152b = []; // ESCAMA CUAD
  lines5ea75b95ece96f572f598255 = []; // HIELO CUADRADO
  lines5ef5e43bdd4795f0c32a152c = []; // BARRA
  lines5ef5e43bdd4795f0c32a152d = []; // BLOQUES
  lines5ef5e43bdd4795f0c32a152e = []; // HIELO SECO
  lines5ef5e43bdd4795f0c32a152f = []; // DESPLAZAMIENTO
  lines5ef5e43bdd4795f0c32a1530 = []; // ALQUILER CAMARAS
  lines5ef5e43bdd4795f0c32a1531 = []; // HIELO ESPECIAL
  lines6509a1e01bb0978fd8b5b15f = []; // CUBO 5X5
  lines6509a4241bb0978fd8b5b161 = []; // LINGOTE 4X12
  lines650dbb3eb78327095c20a226 = []; // ESFERAS 6CM
  lines650aae4834900b974d3fba94 = []; // CUBO 5,5 X 5,5
  lines650aae7934900b974d3fba95 = []; // CUBO 5X7
  lines650aae9a34900b974d3fba96 = []; // LINGOTE 3X15
  lines650aaebe34900b974d3fba97 = []; // ESFERAS 3CM


  nameField: string;
  priceField: number;
  ivaRequered: boolean;
  iva: number;
  tarifas: Tarifa[];
  list = ['5eb9c9e3d0ca13a4332680dc', '5eb9c9e3d0ca13a4332680db', '5eb9c9e3d0ca13a4332680d9',
    '5eb9c9e3d0ca13a4332680da', '5ef5e43bdd4795f0c32a152b', '5ea75b95ece96f572f598255',
    '5ef5e43bdd4795f0c32a152c', '5ef5e43bdd4795f0c32a152d', '5ef5e43bdd4795f0c32a152e',
    '5ef5e43bdd4795f0c32a152f', '5ef5e43bdd4795f0c32a1530', '5ef5e43bdd4795f0c32a1531',
    '6509a1e01bb0978fd8b5b15f', '6509a4241bb0978fd8b5b161', '650dbb3eb78327095c20a226', 
    '650aae4834900b974d3fba94', '650aae7934900b974d3fba95', '650aae9a34900b974d3fba96',
    '650aaebe34900b974d3fba97']

  constructor(private alert: AlertController,
    private rest: RestService,
    private utils: UtilsService
  ) { }

  ngOnInit() {
    this.getTarifas();
  }

  ionViewWillEnter() {
    this.selectedTab = '5eb9c9e3d0ca13a4332680dc';
  }

  changeView(view: string) {
    this.selectedView = view;
  }

  addNew() {
    this.selectedView = 'tarifa';
    this.nameField = '';
    this.priceField = null;
    this.ivaRequered = false;
    this.iva = null;
    this.editFields = false;
    console.log('addnew');
  }

  changedIVA() {
    if (!this.ivaRequered) {
      this.iva = null;
    }
  }

  async getTarifas() {
    this.lines5eb9c9e3d0ca13a4332680dc = [];
    this.lines5eb9c9e3d0ca13a4332680db = [];
    this.lines5eb9c9e3d0ca13a4332680d9 = [];
    this.lines5eb9c9e3d0ca13a4332680da = [];
    this.lines5ef5e43bdd4795f0c32a152b = [];
    this.lines5ea75b95ece96f572f598255 = [];
    this.lines5ef5e43bdd4795f0c32a152c = [];
    this.lines5ef5e43bdd4795f0c32a152d = [];
    this.lines5ef5e43bdd4795f0c32a152e = [];
    this.lines5ef5e43bdd4795f0c32a152f = [];
    this.lines5ef5e43bdd4795f0c32a1530 = [];
    this.lines5ef5e43bdd4795f0c32a1531 = [];
    this.lines6509a1e01bb0978fd8b5b15f = []; 
    this.lines6509a4241bb0978fd8b5b161 = []; 
    this.lines650dbb3eb78327095c20a226 = []; 
    this.lines650aae4834900b974d3fba94 = []; 
    this.lines650aae7934900b974d3fba95 = []; 
    this.lines650aae9a34900b974d3fba96 = [];  
    this.lines650aaebe34900b974d3fba97 = []; 
  
    await this.utils.showLoading();
    const result: any = await this.rest.getTarifas(1, 1000);
    this.tarifas = result.body.records;
    this.tarifas.forEach(tarifa => {
      if (tarifa.product === 'CUBITO VOGT') {
        this.lines5eb9c9e3d0ca13a4332680dc.push(tarifa);
      } else if (tarifa.product === 'CUBITO SCOTSMAN') {
        this.lines5eb9c9e3d0ca13a4332680db.push(tarifa);
      } else if (tarifa.product === 'HIELO PILEE') {
        this.lines5eb9c9e3d0ca13a4332680d9.push(tarifa);
      } else if (tarifa.product === 'ESCAMA RED') {
        this.lines5eb9c9e3d0ca13a4332680da.push(tarifa);
      } else if (tarifa.product === 'ESCAMA CUAD') {
        this.lines5ef5e43bdd4795f0c32a152b.push(tarifa);
      } else if (tarifa.product === 'HIELO CUADRADO') {
        this.lines5ea75b95ece96f572f598255.push(tarifa);
      } else if (tarifa.product === 'BARRA') {
        this.lines5ef5e43bdd4795f0c32a152c.push(tarifa);
      } else if (tarifa.product === 'BLOQUES') {
        this.lines5ef5e43bdd4795f0c32a152d.push(tarifa);
      } else if (tarifa.product === 'HIELO SECO') {
        this.lines5ef5e43bdd4795f0c32a152e.push(tarifa);
      } else if (tarifa.product === 'DESPLAZAMIENTO') {
        this.lines5ef5e43bdd4795f0c32a152f.push(tarifa);
      } else if (tarifa.product === 'ALQUILER CAMARAS') {
        this.lines5ef5e43bdd4795f0c32a1530.push(tarifa);
      } else if (tarifa.product === 'HIELO ESPECIAL') {
        this.lines5ef5e43bdd4795f0c32a1531.push(tarifa);  
      } else if (tarifa.product === 'CUBO 5X5') {
        this.lines6509a1e01bb0978fd8b5b15f.push(tarifa);
      } else if (tarifa.product === 'LINGOTE 4X12') {
        this.lines6509a4241bb0978fd8b5b161.push(tarifa);
      } else if (tarifa.product === 'ESFERAS 6CM') {
        this.lines650dbb3eb78327095c20a226.push(tarifa);
      } else if (tarifa.product === 'CUBO 5,5 X 5,5') {
        this.lines650aae4834900b974d3fba94.push(tarifa);
      } else if (tarifa.product === 'CUBO 5X7') {
        this.lines650aae7934900b974d3fba95.push(tarifa);
      } else if (tarifa.product === 'LINGOTE 3X15') {
        this.lines650aae9a34900b974d3fba96.push(tarifa);
      } else if (tarifa.product === 'ESFERAS 3CM') {
        this.lines650aaebe34900b974d3fba97.push(tarifa);
      }

      if (!tarifa.iva) {
        (tarifa.iva as any) = 'No'
      }
    });
    this.lines5eb9c9e3d0ca13a4332680dc = this.lines5eb9c9e3d0ca13a4332680dc.sort((a, b) => b.price - a.price);
    this.lines5eb9c9e3d0ca13a4332680db = this.lines5eb9c9e3d0ca13a4332680db.sort((a, b) => b.price - a.price);
    this.lines5eb9c9e3d0ca13a4332680d9 = this.lines5eb9c9e3d0ca13a4332680d9.sort((a, b) => b.price - a.price);
    this.lines5eb9c9e3d0ca13a4332680da = this.lines5eb9c9e3d0ca13a4332680da.sort((a, b) => b.price - a.price);
    this.lines5ef5e43bdd4795f0c32a152b = this.lines5ef5e43bdd4795f0c32a152b.sort((a, b) => b.price - a.price);
    this.lines5ea75b95ece96f572f598255 = this.lines5ea75b95ece96f572f598255.sort((a, b) => b.price - a.price);
    this.lines5ef5e43bdd4795f0c32a152c = this.lines5ef5e43bdd4795f0c32a152c.sort((a, b) => b.price - a.price);
    this.lines5ef5e43bdd4795f0c32a152d = this.lines5ef5e43bdd4795f0c32a152d.sort((a, b) => b.price - a.price);
    this.lines5ef5e43bdd4795f0c32a152e = this.lines5ef5e43bdd4795f0c32a152e.sort((a, b) => b.price - a.price);
    this.lines5ef5e43bdd4795f0c32a152f = this.lines5ef5e43bdd4795f0c32a152f.sort((a, b) => b.price - a.price);
    this.lines5ef5e43bdd4795f0c32a1530 = this.lines5ef5e43bdd4795f0c32a1530.sort((a, b) => b.price - a.price);
    this.lines5ef5e43bdd4795f0c32a1531 = this.lines5ef5e43bdd4795f0c32a1531.sort((a, b) => b.price - a.price);
    this.lines6509a1e01bb0978fd8b5b15f = this.lines6509a1e01bb0978fd8b5b15f.sort((a, b) => b.price - a.price);
    this.lines6509a4241bb0978fd8b5b161 = this.lines6509a4241bb0978fd8b5b161.sort((a, b) => b.price - a.price);
    this.lines650dbb3eb78327095c20a226 = this.lines650dbb3eb78327095c20a226.sort((a, b) => b.price - a.price);
    this.lines650aae4834900b974d3fba94 = this.lines650aae4834900b974d3fba94.sort((a, b) => b.price - a.price);
    this.lines650aae7934900b974d3fba95 = this.lines650aae7934900b974d3fba95.sort((a, b) => b.price - a.price);
    this.lines650aae9a34900b974d3fba96 = this.lines650aae9a34900b974d3fba96.sort((a, b) => b.price - a.price);
    this.lines650aaebe34900b974d3fba97 = this.lines650aaebe34900b974d3fba97.sort((a, b) => b.price - a.price);


    await this.utils.hideLoading();
  }
 
  async saveTarifa() {
    const sendTarifa: Tarifa = {
      name: this.nameField,
      price: this.priceField,
      ivaRequered: this.ivaRequered,
      iva: this.iva,
      product: ProductById(this.selectedTab)
    };
    await this.utils.showLoading();
    const result = await this.rest.createTarifa(sendTarifa);
    console.log(result);
    if (result) {
      this.nameField = '';
      this.priceField = null;
      this.ivaRequered = false;
      this.iva = null;
      this.selectedView = 'main';
      this.getTarifas();
    }
    await this.utils.hideLoading();
  }

  getProductName(id) {
    return ProductById(id);
  }

  async editTarifa() {
    const sendTarifa: Tarifa = {
      _id: this.editedId,
      name: this.nameField,
      price: this.priceField,
      ivaRequered: this.ivaRequered,
      iva: this.iva,
      product: ProductById(this.selectedTab)
    };
    if (!sendTarifa.ivaRequered) {
      sendTarifa.iva = null
    }
    await this.utils.showLoading();
    const result = await this.rest.editTarifa(sendTarifa);
    console.log(result);
    if (result) {
      this.selectedView = 'main';
      this.getTarifas();
    }
    await this.utils.hideLoading();
  }

  async doAction(data) {
    console.log(data);
    const tarifa: Tarifa = data.line;
    if (data.action === 'delete') {
      this.deleteItem(tarifa);
    }
    if (data.action === 'edit') {
      console.log('edit');
      this.selectedView = 'tarifa';
      this.editedId = tarifa._id;
      this.nameField = tarifa.name;
      this.priceField = tarifa.price;
      this.ivaRequered = tarifa.ivaRequered;
      this.iva = tarifa.iva;
      this.editFields = true;
    }
  }

  async deleteItem(tarifa: Tarifa) {
    const alert = await this.alert.create({
      header: '¿Borrar?',
      message: 'Borrar tarifa ' + tarifa.name,
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          cssClass: 'secondary'
        }, {
          text: 'Sí',
          handler: async () => {
            console.log('Item to remove!!!');
            await this.utils.showLoading();
            await this.rest.deleteTarifa(tarifa._id);
            this.getTarifas();
            await this.utils.hideLoading();
          }
        }
      ]
    });
    await alert.present();
  }

  checkValidFields() {
    if (this.priceField < 0) {
      return true;
    } else if (this.nameField.length < 1) {
      return true;
    } else {
      return false;
    }
  }
}
